module.exports = __webpack_public_path__ + "static/img/nav_bg.9523b319.png";